import React, { useEffect } from 'react';
import { useTitle } from "../../../contexts/title";
import OutOfStockGrid from '../../../features/distributor/out-of-stock/components/OutOfStockGrid';

export default function OutOfStockPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Out of Stock')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<OutOfStockGrid />
			</div>
		</React.Fragment>
	)
} 
